import styled from 'styled-components';

export const SpinnerContainer = styled.div`
  margin: ${({ margin }) => margin || 0} !important;
  text-align: ${({ align }) => align || 'left'} !important;
  display: block;
`;
